import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IAccount, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromAccount from './state/account.selectors';
import * as AccountAction from './state/account.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, Subscription, skipWhile } from 'rxjs';
// import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
    selector: 'account-screen',
    templateUrl: 'account.component.html',
    styleUrls: ['account.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IAccount | null>;
    stateDataSubscription: Subscription;
    stateData: IAccount | null;

    getData: string = 'ACCT';

    accountCCDetails = [];
    accountCIDetails = [];
    accountPPDetails = [];
    isNullAccountDetails: boolean = false;
    isLoadingAccountDetails: boolean = false;
    showErrorAccountDetails: boolean = false;
    errorMessageAccountDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['code', 'description'];
    // dataSource: MatTableDataSource<any>;


    constructor(
        private store: Store<fromAccount.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }


    ngOnInit() {
        this.startSubscriptions();
        this.getActiveAccountDataCC();
        // this.getActiveAccountDataCI();
        // this.getActiveAccountDataPFTP();
    }
    onTabChange(val) {
        if (val === 1 && this.accountCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveAccountDataCI();
        } else if (val === 2 && this.accountPPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveAccountDataPFTP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }
    getActiveAccountDataCC() {
        this.isLoadingAccountDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.accountCCDetails = data;
                        this.isLoadingAccountDetails = false;
                        // console.log('selected account list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                    } else {
                        // console.log(data);
                        this.isNullAccountDetails = true;
                        this.errorMessageAccountDetails = 'There is not any selected account';
                        this.ref.markForCheck();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingAccountDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorAccountDetails = true;
                    this.errorMessageAccountDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                }
            }
            );
    }

    getActiveAccountDataCI() {
        this.isLoadingAccountDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.accountCIDetails = data;
                        this.isLoadingAccountDetails = false;
                        // console.log('selected account list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullAccountDetails = true;
                        this.errorMessageAccountDetails = 'There is not any selected account';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingAccountDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorAccountDetails = true;
                    this.errorMessageAccountDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveAccountDataPFTP() {
        this.isLoadingAccountDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.accountPPDetails = data;
                        this.isLoadingAccountDetails = false;
                        // console.log('selected account list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullAccountDetails = true;
                        this.errorMessageAccountDetails = 'There is not any selected account';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingAccountDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorAccountDetails = true;
                    this.errorMessageAccountDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }
    editAccountListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    // console.log('account list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Account (CC)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected account CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveAccountDataCC();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editAccountListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    // console.log('account list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Account (CI)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected account CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveAccountDataCI();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editAccountListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    // console.log('account list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Account (PFTP)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected account PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveAccountDataPFTP();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    // Select state
    private selectState(): void {
        this.pending$ = this.store.select(fromAccount.getAccountScreenPending);
        this.stateData$ = this.store.select(fromAccount.getAccountState);
        this.error$ = this.store.select(fromAccount.getAccountScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    private displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new AccountAction.AccountScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}